
/* ------------------------------------------------------------------------ */
/*		File: DetailCourse.tsx                                              */
/*		Description: Detail course page definition                          */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../../components/cmpMenu/cmpMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import { getImage } from "../../components/GenericComponents/functions";
import Card_145 from "../../components/cmpCard_145/cmpCard_145";
import Faq from "../../components/cmpFAQ/cmpFAQ";
import Button from "../../components/GenericComponents/Button";
import "./detailCourse.css"; 
import "../../scss/general.css";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";
import StepBullet from "../../components/cmpStep/cmpStepBullets";
import Modules from "../../components/cmpModules/cmpModules";
import Links from "../../components/cmpLink/cmpLink";
import Popup from "../../components/cmpPopup/cmpPopup";
import Meta from "../../components/GenericComponents/meta";

/* ------------------------------------------------------------------------ */

const DetailCourse: React.FC = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const infoMenus:any = t("menu", { returnObjects: true }); 
    const infoDetailCourse:any = t(`${courseId}`, { returnObjects: true });
    const detailMenu = infoMenus.filter((x:any) => x.id === "courses")[0] || null;

    const [isOpen, setIsOpen] = useState(false);

    const togglePopup = () => { setIsOpen(!isOpen) };


    return (
        <div className="header-parent ">
            <Meta page={`${courseId}`} />
            <div className="cssAbout">
                <Menu 
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                />
                <div className="cssCol">
                    <Card_Breadcumb label={infoDetailCourse.breadcumb} />

                    {/* Section: Detail of a Course */}

                    <section id="detailCourse">
                        <IntroComponent
                            label={infoDetailCourse.label}
                            description={infoDetailCourse.description}
                        />
                    </section>
                    
                    {/* Section: Learning Outcomes */}
                    <section id="learningOutcomes">

                        <IntroComponent
                            label={infoDetailCourse.content[5].label}
                            description={infoDetailCourse.content[5].description}
                        />
                        <div className="cssRowCenter">
                            {infoDetailCourse.content[5].content.map((item:any, index:number) => (
                                <StepBullet
                                    key={`learningOutcomes-${index}`}
                                    label={item.label}
                                    options={item.content}
                                    src={item.src}
                                />
                            ))}
                        </div>   
                        <IntroComponent
                            description={infoDetailCourse.content[5].footer}
                        />

                        <Links
                            card={infoDetailCourse.content[5].link}
                            onClick={togglePopup}
                        />

                        {isOpen && (
                            <Popup 
                                content={
                                    <Modules 
                                        card={infoDetailCourse.content[0]} 
                                        origin={"popup"}
                                        onClick={togglePopup}
                                    />
                                }
                                type="modules"
                                popupOptions={infoDetailCourse.content[0].popup}
                                handleClose={togglePopup}
                            />
                        )} 


                        <div className="detailcourse_button">
                            <Button  
                                classProp={"yellow-button"}
                                label={infoDetailCourse.buttons[0].label}
                                size={"big"}
                                onClick={() => navigate(infoDetailCourse.buttons[0].navigateTo)}
                            />       
                        </div>                      
                    </section>

                    
                    {/* Section: How to Enrol */}

                    <section id="howToEnrol">
                        <IntroComponent
                            label={infoDetailCourse.content[3].label}
                            description={infoDetailCourse.content[3].description}
                        />
                        <div className="cssRowBetween">
                            <div className="detailcourse_enrol">
                                {infoDetailCourse.content[3].content.map((item:any, index:number) => (
                                    <>
                                        <Card_145
                                            key={`Card_145-${index}`}
                                            label={item.label}
                                            description={item.description}
                                            src={item.src}
                                        />
                                        {(index <= (infoDetailCourse.content[1].content.length-1)) && (
                                            <div 
                                                key={`Card_145_Div-${index}`}
                                                className="detailcourse_arrow"
                                            >
                                                <img 
                                                    key={`Card_145_Img-${index}`}
                                                    src={getImage("arrow.svg")} 
                                                    alt={"arrow.svg"}
                                                />
                                            </div>
                                        )}
                                    </>                                    
                                ))}
                            </div>
                        </div>
                        <div className="detailcourse_button">
                            <Button 
                                classProp={"yellow-button"}
                                label={infoDetailCourse.buttons[1].label}
                                size={"big"}
                                onClick={() => navigate(infoDetailCourse.buttons[1].navigateTo)}
                            />   
                        </div>
                    </section>  

                    {/* Section: FAQ */}
                    
                    <section id="faq">
                        <IntroComponent
                            label={infoDetailCourse.content[4].label}
                            description={infoDetailCourse.content[4].description}
                        />
                        <Faq
                            questions={infoDetailCourse.content[4].content}
                        />
                    </section>                                                     
                </div>
            </div>

        </div>
    );
};
export default withTranslation('translation', { withRef: true }) (DetailCourse);


